import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../Button/index.js';
import { formatNumber } from '../../helpers/use-format.js';
import styles from 'ui-components/ActiveFilters.scss';

var DefaultCloseIcon = function DefaultCloseIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.6 4.4l-7.2 7.2M11.6 11.6L4.4 4.4"
  })));
};
var ActiveFilters = function ActiveFilters(_ref) {
  var _cn;
  var className = _ref.className,
    filterState = _ref.filterState,
    _ref$CloseIcon = _ref.CloseIcon,
    CloseIcon = _ref$CloseIcon === void 0 ? DefaultCloseIcon : _ref$CloseIcon,
    _ref$hideEmptyFilters = _ref.hideEmptyFilters,
    hideEmptyFilters = _ref$hideEmptyFilters === void 0 ? false : _ref$hideEmptyFilters;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, filterState.active.filters.length > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeFiltersContainer
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: styles.clearbuttonMobile,
    onClick: filterState.clearAllFilters
  }, t("FILTER.ACTIVE_FILTERS.CLEAR_ALL")), /*#__PURE__*/React__default.createElement("div", {
    className: cn((_cn = {}, _cn[styles.hideEmptyFilters] = hideEmptyFilters, _cn), styles.activeFilters)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeFiltersTop
  }, filterState.active.filters.filter(function (f) {
    return f.code !== "within_balance";
  }).map(function (af) {
    return /*#__PURE__*/React__default.createElement(ActiveFilter, {
      key: af.code,
      label: getFilterText(af, filterState, t),
      clearFilter: function clearFilter() {
        return filterState.toggleFilter(af);
      },
      CloseIcon: CloseIcon
    });
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeFiltersBottom
  }, /*#__PURE__*/React__default.createElement("p", {
    className: styles.totalCount
  }, t("FILTER.ACTIVE_FILTERS.TOTAL_COUNT", {
    count: filterState.totalCount
  })), /*#__PURE__*/React__default.createElement(Button, {
    className: styles.clearbuttonDesktop,
    onClick: filterState.clearAllFilters
  }, t("FILTER.ACTIVE_FILTERS.CLEAR_ALL"))))) : !hideEmptyFilters && /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeFiltersEmpty
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("FILTER.ACTIVE_FILTERS.NO_ACTIVE_FILTERS")))));
};
var getFilterText = function getFilterText(filter, filterState, t) {
  if (typeof filter.value !== "undefined") {
    // Boolean values
    if (filter.value === "1" || filter.value === "0") {
      var pfb = filterState.filters.booleans.find(function (x) {
        return x.code === filter.code;
      });
      if (pfb) {
        return pfb.label || "";
      }
    }

    // Bucket values
    return filter.value;
  }
  var min = typeof filter.minValue === "number" ? formatNumber("" + filter.minValue) : filterState.price.min;
  var max = typeof filter.maxValue === "number" ? formatNumber("" + filter.maxValue) : filterState.price.max;

  // Price values
  if (filterState.autoFilterMinPointsActive !== undefined && filterState.autoFilterMinPointsActive !== null && filterState.autoFilterMinPointsActive === true) {
    return t("FILTER.ACTIVE_FILTERS.WITHIN_BALANCE", {
      range: min + " - " + max
    });
  }
  return t("FILTER.ACTIVE_FILTERS.PRICE_RANGE", {
    range: min + " - " + max
  });
};
var ActiveFilter = function ActiveFilter(_ref2) {
  var label = _ref2.label,
    clearFilter = _ref2.clearFilter,
    CloseIcon = _ref2.CloseIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeFilter,
    onClick: clearFilter
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React__default.createElement("span", null, label)));
};

export { ActiveFilters };
//# sourceMappingURL=index.js.map
